import type { IPickerValue, IDateTypeOption } from '../types';

export const TYPES: IDateTypeOption[] = [
  {
    name: 'dbi_day',
    value: 'date',
  },
  {
    name: 'dbi_week',
    value: 'week',
  },
  {
    name: 'dbi_month',
    value: 'month',
  },
];

export const TYPES_PREFIXS_MAPPING: {
  [key: string]: string;
} = {
  date: 'D',
  week: 'W',
  month: 'M',
};

export const DEFAULT_VALUE_DAY: IPickerValue = {
  type: TYPES[0].value,
  value: ['1', '30'],
};

export const DEFAULT_VALUE_WEEK: IPickerValue = {
  type: TYPES[1].value,
  value: ['1', '4'],
};

export const DEFAULT_VALUE_MONTH: IPickerValue = {
  type: TYPES[2].value,
  value: ['1', '6'],
};
